import React, { useState } from 'react'
import { Box, Dialog, DialogContent, DialogActions } from '@mui/material'
import { Model, PartialShoesAction, ShoesModel, ShoesState } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { ConfirmDialog } from 'src/Components/Ui/ConfirmDialog'
import { useConfirm } from 'src/hooks/useConfirm'
import { ShoesModelCard } from './ShoesModelCard'
import { getStartSimulationMessage } from 'src/logic'

const SET_BASE_MODEL = 'setBaseModel'

type Props = {
  state: ShoesState
  models: ShoesModel[]
  dispatch: React.Dispatch<PartialShoesAction>
  filterLogic?: (m?: Model) => boolean
}

export const ShoesBaseModelSelector: React.FC<Props> = ({ models, dispatch, filterLogic }) => {
  const { isEn, t } = useLocale()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(true)
  const { isConfirmOpen, handleConfirmOpen, handleConfirmClose } = useConfirm()
  const [selectedModel, setSelectedModel] = useState<ShoesModel>()

  const message = getStartSimulationMessage(selectedModel, isEn, t)
  const handleStartSimulation = () => {
    dispatch({ type: SET_BASE_MODEL, baseModel: selectedModel })
    setIsDialogOpen(false)
    handleConfirmClose()
  }
  return (
    <Box>
      <Dialog open={isDialogOpen} maxWidth={'lg'}>
        <DialogContent>
          <Box position={'sticky'} left={0}>
            {t.PLEASE_SELECT_MODEL}
          </Box>
          <Box display={'flex'}>
            {models.map((model) => (
              <ShoesModelCard {...{ selectedModel, model, setSelectedModel }} key={model.productNumber} />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <ConfirmDialog
            isConfirmOpen={isConfirmOpen}
            openButtonLabel={t.START_SIMULATION}
            dialogMessage={message}
            color={'primary'}
            variant={'contained'}
            handleOkButton={handleConfirmOpen}
            handleCancelButton={handleConfirmClose}
            handleExecuteButton={handleStartSimulation}
            disabled={!selectedModel}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}
